






















































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_columnHeaders,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYear_footer,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYear_rows,
} from '@/queries/__generated__/paychecksAndBookkeepingReconciliationReport';
import { workRelationDisplay } from '@/app/WorkRelation';

@Component({})
export default class PaychecksInYearNotPaidInYear extends Vue {
  @Prop({ required: true }) private headers!: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_columnHeaders[];
  @Prop({ required: true }) private rows!: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYear_rows[];
  @Prop({ required: true }) private footer!: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYear_footer[];
  @Prop({ type: Number, required: true }) private year!: number;
  private workRelationDisplay = workRelationDisplay;
}
